import { render, staticRenderFns } from "./readingthree.vue?vue&type=template&id=0ac86e0b&scoped=true"
import script from "./readingthree.vue?vue&type=script&lang=js"
export * from "./readingthree.vue?vue&type=script&lang=js"
import style0 from "./readingthree.vue?vue&type=style&index=0&id=0ac86e0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac86e0b",
  null
  
)

export default component.exports